import { FC, useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import { Space } from "antd";
import Button from "../../../components/UI/Button";
import { Output } from "../../../services/types";
import { getBingoJackpotWinners } from "../../../services/reports";
import { useLoading } from "../../../context/LoadingProvider/useLoading";

const BingoJackpotWinners: FC = () => {
  const loading = useLoading();

  const [report, setReport] = useState<string>("");

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      refreshReport()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const report = await getBingoJackpotWinners({
      output,
    });

    if (Output.isHTML(output)) {
      setReport(report);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="middle" wrap>
        <Button type="primary" onClick={() => refreshReport()}>
          Refresh
        </Button>

        <Button type="primary" onClick={() => refreshReport(Output.CSV)}>
          Save as CSV
        </Button>

        <Button type="primary" onClick={() => refreshReport(Output.PDF)}>
          Save as PDF
        </Button>
      </Space>
    </DefaultFormParserLayout>
  );
};

export default BingoJackpotWinners;
